import { getClientIdWithIdentifier, identifyClient } from '@nackle/bridge';
import { idURL } from './endpoints';
import { toQueryString } from './utils/app-utils';

export const APP_STORAGE_KEY = 'appCode';
export const INTEGRATION_TYPE_KEY = 'source';
export const USER_STORAGE_KEY = 'user';
export const CLIENT_ID = 'outlook-integration-dev';

export async function getUser( refreshToken = '' ) {
    const appCode = localStorage.getItem( APP_STORAGE_KEY );
    // see if the user is in local storage
    let existingUser = localStorage.getItem( USER_STORAGE_KEY );
    if ( existingUser ) {
        existingUser = JSON.parse( existingUser );
    }
    // if the user exists and the token hasn't expired; just return
    if ( existingUser && new Date() < new Date( existingUser.access_token_expires_at ) ) {
        return existingUser;
    }
    // if the user exists; try to refesh the token
    if ( existingUser ) {
        try {
            const res = await fetch( `${ idURL }/token`, 
                {
                    'method': 'POST',
                    'headers': {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    'body': [
                        'grant_type=refresh_token',
                        `client_id=${ encodeURIComponent( getClientIdWithIdentifier( CLIENT_ID, appCode ) ) }`,
                        `refresh_token=${ encodeURIComponent( refreshToken && refreshToken != existingUser.refresh_token ? refreshToken : existingUser.refresh_token ) }`
                    ].join( '&' )
                } );
            const json = await res.json();
            const { access_token, expires_in } = json;
            const newExpire = await getTokenExpire( expires_in );
            const userInfo = await getUserInfo( access_token );
            
            const user = { ...json, access_token_expires_at: newExpire, claims: userInfo, client_id: getClientIdWithIdentifier( CLIENT_ID, appCode ) }; 
            localStorage.setItem( USER_STORAGE_KEY, JSON.stringify( user ) );
            return user;
        }
        catch {
            return null;
        }
    }
    // there was no existing user; or refreshing failed
    return null;
}

export async function testAppCode( appCode ) {
    const { success } = await identifyClient(
        idURL,
        getClientIdWithIdentifier( CLIENT_ID, appCode )
    );
    return success;
}

export async function signIn( code ) {
    const appCode = localStorage.getItem( APP_STORAGE_KEY );
    const res = await fetch( `${ idURL }/token`, 
        {
            'method': 'POST',
            'headers': {
                'content-type': 'application/x-www-form-urlencoded'
            },
            'body': [
                'grant_type=authorization_code',
                `client_id=${ getClientIdWithIdentifier( CLIENT_ID, appCode ) }`,
                `code=${ encodeURIComponent( code ) }`,
                `redirect_uri=${ encodeURIComponent( window.location.origin ) }`
                //`code_verifier=${ encodeURIComponent( codeVerifier ) }`
            ].join( '&' )
        } );
        const json = await res.json();
        const { access_token, expires_in } = json;
        const newExpire = await getTokenExpire( expires_in );
        const userInfo = await getUserInfo( access_token );
        
        const user = { ...json, access_token_expires_at: newExpire, claims: userInfo, client_id: getClientIdWithIdentifier( CLIENT_ID, appCode ) }; 
        localStorage.setItem( USER_STORAGE_KEY, JSON.stringify( user ) );
        return user;
}

const getTokenExpire = ( expires_in ) => {
    const newExpire = new Date();
    newExpire.setSeconds( newExpire.getSeconds() + expires_in );
    return newExpire;
};

const getUserInfo = async ( access_token ) => {
    const meResp = await fetch( `${ idURL }/me`, 
    {
        'method': 'POST',
        'headers': {
            'content-type': 'application/x-www-form-urlencoded',                    
            'authorization': `Bearer ${ access_token }`
        }
    } );
    const userInfo = await meResp.json();
    return userInfo;
};

export async function signOut() {
    const user = await getUser();
    if ( user )
    {
        const appCode = localStorage.getItem( APP_STORAGE_KEY );
        try {
            await fetch( `${ idURL }/token/revocation`, 
                {
                    'method': 'POST',
                    'headers': {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    'body': [
                        `client_id=${ encodeURIComponent( getClientIdWithIdentifier( CLIENT_ID, appCode ) ) }`,
                        `token=${ encodeURIComponent( user.refresh_token ) }`,
                        'token_type_hint=refresh_token'
                    ].join( '&' )
                } 
            );

            let queryParams = {
                id_token_hint: encodeURIComponent( user.id_token ),
                post_logout_redirect_uri: `${ window.location.origin }/oidc_signout`
            };
            let logoutEndpoint = `${ idURL }/session/end?${ toQueryString( queryParams ) }`;
            window.location.assign( logoutEndpoint );
        }
        catch ( error ) {
            console.log( 'Error signing out user', error );
        }
    }
    localStorage.removeItem( USER_STORAGE_KEY );
    localStorage.removeItem( APP_STORAGE_KEY );
    localStorage.removeItem( INTEGRATION_TYPE_KEY );
}
